import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const postHashtagImporterSelectors = importerSelectors(
  'postHashtag.importer',
)

export default postHashtagImporterSelectors
